import { lazy, Suspense } from "react";
import { AppShell } from "./components/AppShell";
import { useRouter } from "./router";

const HomePage = lazy(() => import("./pages/HomePage"));
const SignalsPage = lazy(() => import("./pages/SignalsPage"));
const SignalDetailsPage = lazy(() => import("./pages/SignalDetailsPage"));
const AnalyticsPage = lazy(() => import("./pages/AnalyticsPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage"));
const SubscriptionPage = lazy(() => import("./pages/SubscriptionPage"));
const CalendarPage = lazy(() => import("./pages/CalendarPage"));
const AnalysisPage = lazy(() => import("./pages/AnalysisPage"));
const AiAssistantPage = lazy(() => import("./pages/AiAssistantPage"));
const NotificationsPage = lazy(() => import("./pages/NotificationsPage"));
const AnalysisHistoryPage = lazy(() => import("./pages/AnalysisHistoryPage"));
const PaymentsPage = lazy(() => import("./pages/PaymentsPage"));
const RiskCalculatorPage = lazy(() => import("./pages/RiskCalculatorPage"));
const LegalPage = lazy(() => import("./pages/LegalPage"));
const OnboardingPage = lazy(() => import("./pages/OnboardingPage"));
const MarketStatusPage = lazy(() => import("./pages/MarketStatusPage"));
const ScannerPage = lazy(() => import("./pages/ScannerPage"));
const WatchlistPage = lazy(() => import("./pages/WatchlistPage"));
const ReferralPage = lazy(() => import("./pages/ReferralPage"));
const SupportPage = lazy(() => import("./pages/SupportPage"));

function PageLoader() {
  return (
    <div className="page-loader">
      <div className="skeleton title" />
      <div className="skeleton block" />
      <div className="skeleton block" />
    </div>
  );
}

export function App() {
  const { path } = useRouter();
  const Page =
    path === "/"
      ? HomePage
      : path === "/signals"
        ? SignalsPage
        : path.startsWith("/signals/")
          ? SignalDetailsPage
          : path === "/analytics"
            ? AnalyticsPage
            : path === "/profile"
              ? ProfilePage
              : path === "/subscription"
                ? SubscriptionPage
                : path === "/calendar"
                  ? CalendarPage
                  : path === "/analysis"
                    ? AnalysisPage
                    : path === "/ai"
                      ? AiAssistantPage
                      : path === "/notifications"
                        ? NotificationsPage
                        : path === "/analysis-history"
                          ? AnalysisHistoryPage
                          : path === "/payments"
                            ? PaymentsPage
                            : path === "/risk-calculator"
                              ? RiskCalculatorPage
                              : path === "/legal"
                                ? LegalPage
                                : path === "/onboarding"
                                  ? OnboardingPage
                                  : path === "/market-status"
                                    ? MarketStatusPage
                                    : path === "/scanner"
                                      ? ScannerPage
                                      : path === "/watchlist"
                                        ? WatchlistPage
                                        : path === "/referral"
                                          ? ReferralPage
                                          : path === "/support" ||
                                              path.startsWith("/support/")
                                            ? SupportPage
                                            : HomePage;
  return (
    <AppShell>
      <Suspense fallback={<PageLoader />}>
        <Page />
      </Suspense>
    </AppShell>
  );
}
